// extracted by mini-css-extract-plugin
export default {"navlink_item":"CohortsLayout_navlink_item__3Xl4c","create_new_cohort_div":"CohortsLayout_create_new_cohort_div__orDrZ","filter_form":"CohortsLayout_filter_form__mGM-A"};